import publicApi from '@/services/publicApi';
import { getToken } from '@/services/auth';
import { parseParams } from '@/services/util';

// Vitrine pública ({tenant}.repasys.com.br/vitrine): sempre sobre o publicApi (sem interceptors), porque a tela é
// aberta a visitantes. Contrato em repasys.monolith/docs/plans/vitrine-publica/PLANO-IMPLEMENTACAO.md.

const CONFIG_TTL_MS = 60 * 1000;
let configCache = null; // { valor, expiraEm }

// O router consulta a config a cada navegação para "/": cache em memória por 60 s (o mesmo max-age da API).
export async function config() {
  if (configCache && configCache.expiraEm > Date.now()) return configCache.valor;
  const { data } = await publicApi.get('/v3/vitrine/config');
  configCache = { valor: data, expiraEm: Date.now() + CONFIG_TTL_MS };
  return data;
}

export function limparCacheConfig() {
  configCache = null;
}

export function listar(params) {
  return publicApi.get('/v3/vitrine', {
    params,
    paramsSerializer: p => parseParams(p),
  });
}

export function filtros() {
  return publicApi.get('/v3/vitrine/filtros');
}

// Bearer opcional, como PublicVehicle.buscar: lojista aprovado do tenant recebe também codigoNegociacao.
export function detalhe(codigo, comLogin) {
  const headers = comLogin ? { Authorization: getToken() } : {};
  return publicApi.get(`/v3/vitrine/${encodeURIComponent(codigo)}`, { headers });
}

export function contatoWhatsApp(codigo) {
  return publicApi.post(`/v3/vitrine/${encodeURIComponent(codigo)}/contato-whatsapp`);
}

export default { config, limparCacheConfig, listar, filtros, detalhe, contatoWhatsApp };
